import KunLoading21 from './src/index'

KunLoading21.install = function (Vue) {
	Vue.component(KunLoading21.name, KunLoading21);
}

export default KunLoading21;
